export const en = {
    emptyPayer: 'Select a payer',
    emptyPaymentMethod: 'Select a payment method',
    emptySum: 'Set the disconnection threshold',
    gteMessage: "The disconnection threshold is too high. It can't exceed the maximum value of {maxValue} {currency}",
    lteMessage: 'The disconnection threshold is too low. It must be at least {minValue} {currency}',
    nanSum: 'Invalid disconnection threshold'
};
